import type { BoundActions, HookFunction, StoreActionApi } from 'react-sweet-state';
import { createHook } from 'react-sweet-state';

import type { ContentTreeSelectionState } from '../store.ts';
import { MultiSelectMode, Store } from '../store.ts';
import type { ContentId } from '../contentTreeItemType.ts';

export const useIsMultiSelectActive: HookFunction<
	boolean,
	BoundActions<
		ContentTreeSelectionState,
		{
			getState: () => ({ getState }: { getState: any }) => any;
			enterMultiSelect: () => ({ setState }: StoreActionApi<ContentTreeSelectionState>) => void;
			exitMultiSelect: () => ({ setState }: StoreActionApi<ContentTreeSelectionState>) => void;
			disableMultiSelect: () => ({ setState }: StoreActionApi<ContentTreeSelectionState>) => void;
			getSelectedDescendantCount: (
				contentId: ContentId,
			) => ({ getState }: StoreActionApi<ContentTreeSelectionState>) => number;
			updateTotalCount: (
				delta: number,
			) => ({ getState, setState }: StoreActionApi<ContentTreeSelectionState>) => void;
			updateSelectedDescendantsCount: (
				contentId: ContentId,
				descendantCount: number,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			updateParent: (
				contentId: ContentId,
				parentId: ContentId,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			selectNestedContent: (
				items: {
					id: ContentId;
					parentId?: ContentId;
				}[],
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			incrementAncestors: (
				ancestorIds: ContentId[],
				currentContentSelectionCount: number,
				countToRemove: number,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			decrementAncestors: (
				ancestorIds: ContentId[],
				currentContentId: string,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			deselectNestedContent: (
				contentIds: ContentId[],
				parentIds: ContentId[],
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			clearSelection: () => ({ setState }: StoreActionApi<ContentTreeSelectionState>) => void;
			addLoadingDescendant: (
				contentId: ContentId,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
			removeLoadingDescendant: (
				contentId: ContentId,
			) => ({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => void;
		}
	>,
	void
> = createHook(Store, {
	selector: (state) => state.multiSelectMode === MultiSelectMode.ACTIVE,
});
